import React, { useState } from 'react';
import { useMediaQuery } from "react-responsive";
import './DialogVersante.css';

import * as XLSX from 'xlsx';
import DataTable from 'react-data-table-component';
import { useTable } from 'react-table';
import { MdOutlineFileUpload, MdOutlineFileDownload  } from "react-icons/md";

import { getLocale } from '../../locales/getLocale';
import { plainRetrieve, plainStore } from '../../utils/safeStoring';
import { getDarkModePreference  } from '../../utils/themes';
import { tableSpecs } from './tableSpecs';

import SlDialog from '@shoelace-style/shoelace/dist/react/dialog';
import SlButton from '@shoelace-style/shoelace/dist/react/button';



function DialogVersante ({ isOpen, setIsOpen }) {

    const appTheme = plainRetrieve('appTheme') || 'system';
    const systemDarkMode = useMediaQuery({ query: '(prefers-color-scheme: dark)' });
    const isDarkMode = getDarkModePreference (appTheme, systemDarkMode);

    const [data, setData] = useState(plainRetrieve('infoVersante') || []);

    
    const handleSave = () => {
        plainStore('infoVersante', data);
        setIsOpen(false);
    }

    const handleUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
    
        const reader = new FileReader();
        reader.onload = (e) => {
            const binaryStr = e.target.result;
            const workbook = XLSX.read(binaryStr, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet);

            setData(jsonData);
        };
        reader.readAsBinaryString(file);
    };
    
    // Convert JSON to XLSX file and download
    const handleDownload = () => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "elenco_versanti.xlsx");
    };

    
    return (
        <SlDialog 
            className='dialog-versante'
            label={getLocale('DialogVersante.title')}
            open={isOpen} 
            onSlRequestClose={() => setIsOpen(false)}
        >
        
            <div className="dialog-versante-body">

                {data.length > 0 && (
                    <div>
                        <DataTable
                            theme={isDarkMode ? 'dark' : 'light'}
                            columns={tableSpecs.columns}
                            data={data}
                            pagination
                            highlightOnHover
                            responsive
                        />
                    </div>
                )}

                <div className='row-file-op'>

                    <button className='btn-file-op' onClick={() => document.getElementById("input-upload").click()}>
                        <MdOutlineFileUpload />
                        <span style={{ marginRight: '4px' }}>Carica file Excel</span>
                        <input
                            id="input-upload"
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleUpload}
                            style={{ display: 'none' }}
                        />
                    </button>

                    {data.length > 0 && (
                        <button className='btn-file-op' onClick={handleDownload}>
                            <MdOutlineFileDownload />
                                <span style={{ marginRight: '4px' }}>Scarica</span>
                        </button>
                    )}

                </div>
            
            </div>

            <SlButton slot="footer" variant="primary" onClick={() => handleSave()} disabled={data.length === 0}>
                {getLocale('DialogVersante.btnSave')}
            </SlButton>
        
        </SlDialog>
    );
};


export default DialogVersante;
